<template>
  <!--      二次内容分发-->
  <div :class="getCss('container')" v-if="show" v-transfer-dom>
    <!--  外边蒙层  -->
    <transition>
      <div
        v-if="show"
        :class="getCss('ceiba-base-dialog-mask')"
        @click="closeBindOrderPhone()"
      ></div>
    </transition>
    <!--    eslint-disable-next-line max-len-->
    <div
      :class="[
        'content-area',
        !onCloseAnimation
          ? 'ceiba-base-dialog-wrap-isBottom'
          : 'ceiba-base-dialog-wrap-isBottom-close-animation',
      ]"
      ref="content"
      :style="upglideLooeMoreStyle"
    >
      <!--     顶部黑点-->
      <div :class="getCss('top-black-bar-area')"></div>
      <!--     关闭icon-->
      <div :class="getCss('close-icon-area')" @click="closeBindOrderPhone()">
        <span :class="getCss('close-left-side-icon')"></span>
        <span :class="getCss('close-right-side-icon')"></span>
      </div>
      <!--     关闭icon-->
      <!--  滚动区域    https://gameresource.itop.qq.com/ff7761442a5335aceb9abe72ad1be4f2cbc0d64c.png    -->
      <!-- 当 -->
      <div :class="getCss('content-scroll-area')" :style="marginTopSytle">
        <div
          :class="getCss('game-book-show-area')"
          v-if="subscribeGameChannel === 'xy'"
        >
          <img :class="getCss('game-icon')" :src="gameIcon" alt="" />
          <p :class="getCss('game-book-success-text')">预约成功</p>
          <p :class="getCss('game-book-note-text')" v-if="showPhone">
            游戏和礼包上线将短信通知你<br />
            {{ phoneFormat(showPhone) }}
            <img
              src="https://game.gtimg.cn/images/js/img/tgclub/edit.png"
              alt=""
              @click.self="editPhoneClick"
            />
          </p>
          <div
            v-else
            :class="getCss('game-book-notice')"
            @click="bindPhoneClick"
          >
            开启礼包上线通知
          </div>
        </div>
        <div
          :class="getCss('sx-game-book-show-area')"
          v-if="subscribeGameChannel === 'sx'"
        >
          <div
            :class="getCss('tan-kuang-div-img')"
            :style="tanKuangDivImg"
          ></div>
          <div :class="getCss('tan-kuang-div')"><span>预约成功</span></div>
        </div>
        <template
          v-if="!loading && cardNum > 0 && subscribeGameChannel === 'xy'"
        >
<!--          <template-->
<!--            v-for="(itemList ) in showLookMoreButton-->
<!--              ? hotClubList-->
<!--              : [hotClubList[0]]"-->
<!--          >-->
            <!-- 热门俱乐部推荐        -->
          <template  v-if="hotClubList.length > 0">
          <div
              :class="getCss('hot-club-list')"
              v-for="(itemList ) in showLookMoreButton
              ? hotClubList
              : [hotClubList[0]]"
              :key="itemList.traceId"
            >
              <div :class="getCss('card-title')">{{ itemList.cardTitle }}</div>
              <!-- <div :class="getCss('hot-club-area')"></div> -->
              <div
                :class="getCss('card-content')"
                v-for="(item) in showLookMoreButton
                  ? itemList.cards
                  : [itemList.cards[0]]"
                :key="item.feeds_player_club.club_id"
                @click="
                        goToCardUrl(
                          item.feeds_player_club.card_meta.card_redirect_url,
                          itemList.traceId
                        )
                      "
              >
                <div
                  :class="getCss('hot-club-item')"
                  :style="contentStyle(item)"
                >
                  <div :class="getCss('hot-club-item-left')">
                    <p :class="getCss('club-game-name')">
                      {{ item.feeds_player_club.card_meta.card_sub_title }}
                    </p>
                    <p :class="getCss('club-name')">
                      {{ item.feeds_player_club.card_meta.card_title }}
                    </p>
                    <div :class="getCss('club-feature-list')">
                      <div
                        :key="clubFeature+clubFeatureIndex"
                        :class="getCss('club-feature')"
                        v-for="(clubFeature,clubFeatureIndex) in item.feeds_player_club.sub_titles"
                      >
                        {{ clubFeature }}
                      </div>
                      <!-- <div :class="getCss('club-feature')">俱乐部主播带队</div>
                    <div :class="getCss('club-feature')">肝帝众多 福利多多</div>
                    <div :class="getCss('club-feature')">姐妹多，群聊不断</div> -->
                    </div>
                  </div>
                  <div :class="getCss('hot-club-item-right')">
                    <img
                      :class="getCss('hot-club-icon')"
                      :src="item.feeds_player_club.club_icon"
                      alt=""
                    />
                    <!--eslint-disable-next-line max-len-->
                    <p
                      :class="getCss('hot-club-look')"
                    >
                      去看看<img
                        src="https://game.gtimg.cn/images/js/img/tgclub/towardks.png"
                        alt=""
                      />
                    </p>
                  </div>
                </div>
                <p :class="getCss('hot-club-title')">
                  <!--eslint-disable-next-line max-len-->
                  <img
                    :src="item.feeds_player_club.recommend_reason_icon"
                    alt=""
                  />
                  热门俱乐部推荐
                </p>
              </div>
            </div>
            </template>

            <!-- 公众号推荐 -->
          <template  v-if="XyMore === false && recommendOfficialAccountsList.length > 0">
            <div
                 v-for="(officialItem) in recommendOfficialAccountsList"
                 :key="officialItem.traceId"
            >

              <div
                :class="getCss('attention-gzh-item-list')"
              >
                <div :class="getCss('card-title')">
                  {{ officialItem.cardTitle }}
                </div>
                <div :class="getCss('attention-gzh-item')"
                     v-for="(cardItem, cardItemIndex) in officialItem.cards"
                     :key="cardItemIndex"
                >
                  <img
                    :class="getCss('attention-gzh-item-img')"
                    :src="cardItem.chat_group_card.icon_url"
                  />
                  <div :class="getCss('attention-gzh-item-image')"></div>
                  <div :class="getCss('attention-gzh-item-title')">
                    {{ cardItem.chat_group_card.card_meta.card_title }}
                  </div>
                  <div :class="getCss('gzh-feature-list')">
                    <div
                      :key="gzhFeatureIndex"
                      :class="getCss('gzh-feature')"
                      v-for="(gzhFeature,gzhFeatureIndex) in cardItem.chat_group_card.sub_titles"
                    >
                      <img
                        :class="getCss('gzh-feature-icon')"
                        src="https://game.gtimg.cn/images/tgclub/act_tgclub_a20221124/Frame.jpg"
                      />
                      <span> {{ gzhFeature }} </span>
                    </div>
                  </div>
                  <div
                    :class="getCss('attention-gzh-item-btn')"
                    @click="
                      goToCardUrl(
                        cardItem.chat_group_card.button_redirect_url,
                        officialItem.traceId
                      )
                    "
                  >
                    {{ cardItem.chat_group_card.button_text }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!--          </template>-->
        </template>
        <template v-if="subscribeGameChannel === 'sx'">
          <template v-for="(item, index) in dialogConfig">
            <div :key="index" :class="getCss('sx-config-item')">
              <img :src="item.iconImage" />
              <div :class="getCss('sx-config-item-center')">
                <div :class="getCss('config-item-title')">{{ item.title }}</div>
                <div :class="getCss('config-item-content')">
                  {{ item.content }}
                </div>
                <!-- 0.28rem -->
              </div>
              <div
                :class="getCss('sx-config-item-jump')"
                :style="jumpStyles(item.jumpImage)"
                @click="jumpAward(item.link)"
              ></div>
            </div>
          </template>
        </template>
        <div
          v-if="loading && subscribeGameChannel === 'xy'"
          :class="getCss('content-scroll-area-loading')"
        >
          <img
            :class="getCss('gzh-feature-icon-loading')"
            src="https://game.gtimg.cn/images/tgclub/act_tgclub_a20221124/Vector.jpg"
          />加载中...
        </div>
        <div
          v-if="XyMore && subscribeGameChannel === 'xy'"
          :class="getCss('upglide-look-more')"
          @click.self="upglideLooeMoreClick()"
        >
          <img
            src="https://game.gtimg.cn/images/tgclub/act_tgclub_a20221124/upglide-look-more.png"
            alt=""
          />
          上滑查看更多
        </div>
        <div
          v-if="SxMore && subscribeGameChannel === 'sx'"
          :class="getCss('upglide-look-more')"
          @click.self="upglideLooeMoreClick()"
        >
          <img
            src="https://game.gtimg.cn/images/tgclub/act_tgclub_a20221124/upglide-look-more.png"
            alt=""
          />
          上滑查看更多
        </div>
      </div>
      <!--  滚动区域        -->
    </div>
    <!--   begin 填写手机号弹框 -->
    <c-base-dialog
      v-model="isShowBindPhone"
      :option="rankOption"
      @close="handleBindPhoneClose()"
      v-transfer-dom
      :class="getCss('bind-phone-dialog')"
    >
      <template slot="body">
        <div class="pop_wrap">
          <div class="input-order-set-phone-container">
            <div>
              <input
                class="pop_input"
                v-model="phone"
                @keyup.delete="deleteChange"
                @blur="blueChange"
                type="text"
                maxlength="11"
                :placeholder="placeholderPhone"
              />
            </div>
            <p class="phone-container-text">
              {{ remindText }}
            </p>
            <button
              :class="
                phone.length < 11
                  ? 'input-order-phone-submit-btn'
                  : 'input-order-phone-submit-btn-off'
              "
              :disabled="phone.length < 11"
              @click="save"
            >
              确定
            </button>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!--  end  填写手机号弹框 -->
    <!--     滚动页面-->

    <!--   黑条  -->
    <!--   展示 新版预约结构  -->
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import { tool, TgclubApi } from '@tencent/ceiba-tgclub-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
// import { tool, TgclubApi } from '../ceiba-tgclub-base-components';
import Vue from 'vue';
const SUBSCRIBE_GAME_CHANNEL_XINYUE = 'xy'; // 预约游戏渠道心悦-xy 闪现-sx
const SUBSCRIBE_GAME_CHANNEL_SPARK = 'sx';
const TGCLUB = 'TGCLUB';
const SPARK = 'SPARK';
export default {
  name: 'CTgclubGameOrderBindPhonePop',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    subscriptionData: {
      type: Object,
      default: () => ({}),
    },
    configurationData: {
      type: Object,
      default: () => ({}),
    },
    // mustAppBookDialog: {
    //   type: Boolean,
    //   default: false,
    // }
  },
  data() {
    return {
      loading: true,

      onCloseAnimation: false, // 动画开关
      onCloseAnimationTimeId: null,
      backgroundVar: '#B3ACA4',
      show: false,
      cssPrefix: 'public-s-d-content-pop-',
      wifiAutoDownloadDisabled: true,
      placeholderPhone: '请输入手机号码',
      isFocusOn: false,
      openNoticeMsg: true,
      showLookMoreButton: false, // 查看更多
      cardNum: -1, // 查看更多
      switchStatus: 0, // 0 打开 1 关闭
      packageName: '', // 游戏包
      gameIcon:
        'https://gameresource.itop.qq.com/ff7761442a5335aceb9abe72ad1be4f2cbc0d64c.png', // 游戏icon
      gameName: '', // 游戏名称
      nickname: '',
      height: 0,

      clubLinkListInfo: [],

      contentRef: '',
      index: 0,
      // item: {};

      // 绑定手机号
      isShowBindPhone: false,
      formTag: 'bind_phone',
      phone: '',
      showPhone: '',
      methods: 'create',
      tgclubPhone: '',
      mobilePhone: '',
      remindText:
        '填写的手机号码将用于接收心悦俱乐部的活动、更新等消息通知(可在App设置中关闭)',

      // 操作
      // operationShow: false,
      startX: 0,
      startY: 0,
    };
  },
  computed: {
    //   热门俱乐部
    hotClubList() {
      return this.clubLinkListInfo.filter(item => item.card_type ===  210);
    },
    //   推荐公众号
    recommendOfficialAccountsList() {
      return this.clubLinkListInfo.filter(item => item.card_type ===  223);
    },
    // 预约游戏渠道
    subscribeGameChannel() {
      let astName = TGCLUB;
      if (this.$ast.currentAstName) {
        astName = this.$ast.currentAstName();
      }
      if (astName === TGCLUB) {
        return SUBSCRIBE_GAME_CHANNEL_XINYUE;
      }
      if (astName === SPARK) {
        return SUBSCRIBE_GAME_CHANNEL_SPARK;
      }
      return SUBSCRIBE_GAME_CHANNEL_XINYUE;
    },
    SxMore() {
      return (
        !this.showLookMoreButton
        && this.configurationData.dialogConfig?.length > 2
      );
    },
    XyMore() {
      return this.cardNum > 1 && this.showLookMoreButton === false;
    },
    contentStyle() {
      return item => ({
        '--background': item.feeds_player_club.theme_color,
        '--backgroundImage': `url(${item.feeds_player_club.bg_image_url})`,
      });
    },
    upglideLooeMoreStyle() {
      console.log(this.cardNum, 'this.cardNum');
      if (
        this.cardNum === 0
        && this.subscribeGameChannel === SUBSCRIBE_GAME_CHANNEL_XINYUE
      ) {
        return {
          height: '4.2rem',
          '--onPopHeight': '4.2rem',
        };
      }
      return {
        height: this.showLookMoreButton
          ? '12.5rem'
          : this.subscribeGameChannel === 'xy'
            ? '9rem'
            : '8rem',
        '--onPopHeight': `-${this.showLookMoreButton ? '12.5rem' : '100%'}`,
      };
    },
    computedStyle() {
      const { buttonFontStyle = {} } = this.styles;
      return {
        cursor: 'pointer',
        position: 'static',
        left: 0,
        bottom: 0,
        ...buttonFontStyle,
      };
    },
    rankOption() {
      return {
        fotter: true,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        header: '绑定手机号',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '4.5rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.38rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        titleStyle: {
          fontWeight: 600,
          fontSize: '0.32rem',
        },
        maskClickable: true,
      };
    },
    // end  填写手机号弹框
    isWX() {
      if (this.$actInfo && this.$ast.isAPP()) {
        return common.tool.getCookie('acctype') === 'wx';
      }
      return this.$platform.isWX;
    },
    isIOS() {
      return this.$platform.isIos;
    },
    marginTopSytle() {
      return {
        marginTop: `${this.marginTop / 100}rem`,
      };
    },

    // sx
    tanKuangDivImg() {
      return Object.assign(
        {},
        {
          backgroundImage: `url(${
            this.configurationData.dialogTopImage
              ? this.configurationData.dialogTopImage
              : ''
          })`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'center',
          'background-position-y': 'center',
        },
      );
    },
    jumpStyles() {
      return Image => ({
        backgroundImage: `url(${Image ? Image : ''})`,
      });
    },
    dialogConfig() {
      const { dialogConfig } = this.configurationData;
      return dialogConfig?.length > 2 && !this.showLookMoreButton
        ? dialogConfig?.slice(0, 2)
        : dialogConfig;
    },
  },
  watch: {
    subscriptionData: {
      deep: true,
      handler(newValue) {
        const { mobile, isFocusOn, switchStatus, nickname } = newValue;
        // this.placeholderPhone = mobile || '请输入手机号码';
        this.mobilePhone = mobile;
        this.openNoticeMsg = switchStatus === 0;
        this.isFocusOn = isFocusOn;
        this.nickname = nickname;
        console.log(this.$astTgclubPlugin.currentAstName(), '2343213');
        this.initGameInfo();
      },
    },
    openNoticeMsg: {
      handler(newVal) {
        this.switchStatus = newVal ? 0 : 1;
        console.log('this.switchStatus ', this.switchStatus);
      },
      immediate: true,
    },
    value: {
      async handler(newVal, oldValue) {
        // 关闭 触发css 动画
        if (newVal === false && !!oldValue === true) {
          this.onCloseAnimation = true;
          // 关闭
          const that = this;
          this.onCloseAnimationTimeId = setTimeout(() => {
            that.show = false;
            that.visible();
          }, 200);
          return;
        }
        // 打开的 切换className 实现css动画
        if (newVal === true && !!oldValue === false) {
          await this.getCommonRecommendEncodeCardByScene();
          this.popBindPhone();
          this.initListenScrollerEvent();
          this.onCloseAnimation = false;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('configurationData pop bind phone=', this.configurationData);
    await this.initialize();
  },
  beforeDestroy() {
    // 某种情况先可能出现
    if (this.onCloseAnimationTimeId) {
      clearTimeout(this.onCloseAnimationTimeId);
    }
  },
  methods: {
    async initGameInfo() {
      //  预约拉去icon
      let url = `https://agw.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${this.subscriptionData.gid}`;
      if (window.CEIBA_ENV !== 'prod') {
        url = `https://agw-p.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${this.subscriptionData.gid}`;
      }
      const response = await this.$axiosInstance.get(url);
      const { ret, data = {} } = response;
      const { ret: resRet } = data;
      if (ret !== 0 || resRet !== 0) {
        this.$alert({ msg: '获取游戏信息失败，请稍后重试' });
        return null;
      }
      const { game_name: gameName, icon } = data.GameInfos || {};
      this.gameIcon = icon;
      this.gameName = gameName;
    },
    initListenScrollerEvent() {
      if (
        this.subscribeGameChannel === SUBSCRIBE_GAME_CHANNEL_XINYUE
        && this.clubLinkListInfo[0]?.cards.length <= 1
      ) {
        return false;
      }
      if (
        this.subscribeGameChannel === SUBSCRIBE_GAME_CHANNEL_SPARK
        && this.configurationData.dialogConfig?.length <= 2
      ) {
        return false;
      }
      this.contentRef = this.$refs.content;
      if (this.contentRef) {
        this.contentRef.addEventListener('touchstart', this.touchstart);
        this.contentRef.addEventListener('touchend', this.touchend);
      }
    },
    touchstart(event) {
      event.stopPropagation();
      this.startX = event.changedTouches[0].pageX;
      this.startY = event.changedTouches[0].pageY;
    },
    touchend(event) {
      const moveEndX = event.changedTouches[0].pageX;
      const moveEndY = event.changedTouches[0].pageY;
      const X = moveEndX - this.startX;
      const Y = moveEndY - this.startY;
      if (Math.abs(Y) - Math.abs(X) && Y < -50) {
        this.showLookMoreButton = true;
        this.contentRef.removeEventListener(
          'touchstart',
          this.touchstart,
          false,
        );
        this.contentRef.removeEventListener('touchend', this.touchend);
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initialize() {},
    // 用户填写的跳转地址 如果没有trace_id  则加上
    handleLinkAddTraceId(link, traceId) {
      const currentTraceId = common.tool.getQueryparams('trace_id', link);
      // 已经有trace_id
      if (currentTraceId) {
        return link;// 原跳转地址已经有trace_id
      }
      return this.setUrlParam('trace_id', traceId, link);
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async syncToLogicStatus(url) {
      if (!url) {
        return false;
      }
      const domain = url.split('//')[1]?.split('/')[0];
      if (!domain) {
        return false;
      }
      await new Promise((resolve) => {
        try {
          Vue.prototype.$miloCore?.loginStatus?.syncToQQ(
            domain,
            {
              appid: this.$store?.getters?.userAuth?.['T-APPID'] || '',
              openid: this.$store?.getters?.userAuth?.['T-OPENID'] || '',
              access_token:
                this.$store?.getters?.userAuth?.['T-ACCESS-TOKEN'] || '',
              acctype: this.$store?.getters?.userAuth?.['T-ACCOUNT-TYPE'] || '',
            },
            () => {
              console.log(' syncToLogicStatus sync login status');
              resolve();
            },
          );
        } catch (err) {
          console.error('syncToLogicStatus syncToQQ==', err);
        }
      });
    },
    // 跳转上报
    reportFunc(link) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'open_url',
          eventData: { url: link },
        };
        this.reportClickRaw(params);
        console.log('reportFunc open_url data =', params);
      }
    },
    setUrlParam(name, value, link) {
      let url = link || location.href;
      const reg = new RegExp(`[?&#]${name}=([^&#]*)`, 'gi');

      const matches = url.match(reg);

      const key = `{key${new Date().getTime()}}`;
      let strArr;

      if (matches && matches.length > 0) {
        strArr = matches[matches.length - 1];
      } else {
        strArr = '';
      }
      const extra = `${name}=${value}`;
      // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉
      if (strArr) {
        const first = strArr.charAt(0);
        url = url.replace(strArr, key);
        url = url.replace(key, value ? first + extra : '');
      } else if (value) {
        // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
        if (url.indexOf('?') > -1) {
          url += `&${extra}`;
        } else {
          url += `?${extra}`;
        }
      }
      // 其它情况直接返回原url
      return url;
    },
    // 点击去看看跳转
    async goToCardUrl(link, traceId) {
      // 当url存在trace_id的时候跳转（或者拉起app）的时候带到下游去，如果没有就生成一个带到下游去
      this.reportFunc(link);
      this.reportFlush();
      console.log('jump link begin sleep  200 ms ');
      await this.doSleep(200);
      console.log('jump link end sleep  200 ms ');
      //  tgclub://  协议的目标地址 不需要同步登录态
      // if (needSyncLoginStatus === true && link.indexOf('tgclub://') === -1) {
      //   console.log('access syncToLogicStatus  ');
      //   await that.syncToLogicStatus(link);
      // }
      // eslint-disable-next-line no-param-reassign
      link = this.handleLinkAddTraceId(link, traceId);
      if (window.Tgclub) {
        // 心悦openNewPage方法 的 不支持 tgclub://协议跳转
        if (link.indexOf('tgclub://') === -1) {
          window.Tgclub.openNewPage(link);
        } else {
          window.location.href = link;
        }
        return;
      }
      // 其他业务跳转
      this.$ast.openView({ url: link });
    },
    async getCommonRecommendEncodeCardByScene() {
      this.loading = true;
      const params = { scene: 117, gid: this.subscriptionData.gid };
      const response = await TgclubApi.getCommonRecommendEncodeCardByScene(params);
      console.log('getCommonRecommendEncodeCardByScene response =', response);
      const { ret, msg, out = [] } = response;
      if (ret !== '0') {
        this.clubLinkListInfo = [];
        return this.$alert({ msg: msg || '获取推荐俱乐部信息失败' });
      }
      if (out.length  === 0) {
        this.clubLinkListInfo = [];
        return false;
      }
      const clubInfoLinks = [];
      this.show = true;
      let cardNum = 0;
      console.log(out);
      out.forEach((item) => {
        if (typeof item.encoded_card === 'string' && item) {
          const temp = JSON.parse(item.encoded_card) || {};
          const falg = temp.cards?.some(el => el.card_type === 210 || el.card_type === 223);
          if (falg && temp.cards.length > 0) {
            cardNum = cardNum + temp.cards.length;
            const { card_title: cardTitle, trace_id: traceId } =              temp.card_meta || {};
            clubInfoLinks.push({
              cardTitle,
              traceId,
              cards: temp.cards,
              card_type: temp.cards[0].card_type,
            });
          }
        }
      });
      this.clubLinkListInfo = clubInfoLinks;
      console.log('this.clubLinkListInfo = ', this.clubLinkListInfo);
      this.loading = false;
      this.cardNum = cardNum;
    },
    stop() {
      document.body.style.overflow = 'hidden';
    },
    visible() {
      document.body.style.overflow = 'visible';
    },
    // 初始化手机号
    popBindPhone() {
      this.stop();
      this.initQueryPhone();
      if (typeof this.reportClickRaw === 'function' && this.phone) {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'show_phone',
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    async initQueryPhone() {
      console.log(this.subscriptionData, 'this.subscriptionData');
      if (this.mobilePhone) {
        this.showPhone = this.mobilePhone;
      }
      // 从心悦app绑定手机号查询
      const tgclubResponse = await TgclubApi.getTgclubPhoneBind();
      console.log('checkPhoneFlowId  tgclubResponse = ', tgclubResponse);
      console.log(
        'checkPhoneFlowId  tgclubResponse = ',
        tgclubResponse.data.phone,
      );
      if (tgclubResponse.data.phone) {
        //  心悦查询到的手机号 > 从活动本页手机号查询
        this.tgclubPhone = tgclubResponse.data.phone;
      }
      this.phone = this.phoneFormat(this.tgclubPhone ? this.tgclubPhone : this.mobilePhone);
      if (typeof this.reportClickRaw === 'function' && this.phone) {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'pull_phone',
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    editPhoneClick() {
      this.isShowBindPhone = true;
    },
    // 点击是否换绑手机号
    phoneFormatIsOk(phone) {
      return /^1[3456789]\d{9}$/.test(phone);
    },
    deleteChange() {
      if (this.phone.indexOf('*') > 0) {
        this.phone = '';
      }
    },
    async save() {
      let phone = '';
      if (this.phone.indexOf('*') > 0) {
        phone = this.tgclubPhone;
      } else {
        phone = this.phone;
      }
      if (!this.phoneFormatIsOk(phone)) {
        return this.$toast('请输入正确格式手机号');
      }

      const reportData = {
        gid: this.subscriptionData.gid,
        mobile: phone && this.phoneFormatIsOk(phone) ? phone : '',
        countrycode: '86',
        switch_status: this.openNoticeMsg ? 0 : 1,
      };
      this.reservationPhoneNumberBind(reportData, reportData.mobile);

      // this.handleClose(true);
    },
    // 绑定预约手机号
    async reservationPhoneNumberBind(parasm, phone) {
      const response = await TgclubApi.saveMobSubscription(parasm);
      console.log('saveMobSubscription response  =', response);
      const { ret, msg } = response || {};
      if (ret !== 0) {
        this.$alert({ msg: msg || '操作失败' });
        this.reportBindPhoneFunc('0');
      }
      this.reportBindPhoneFunc('1');
      this.$toast('提交成功');
      this.showPhone = phone;
      this.isShowBindPhone = false;
      if (!this.isIOS) {
        this.reportSilentDownload();
        return false;
      }
    },
    showCommonDialog() {
      if (window.Tgclub) {
        const data = {
          type: 5,
          pageId: this.$actInfo?.page_id,
          activityId: `${this.$actInfo?.activity_id}`,
          phoneNum: this.phoneNum,
        };
        const json = JSON.stringify(data);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        window.Tgclub.showCommonDialog(json, () => {});
      }
    },
    reportModifyPhoneFunc(status) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'modify_phone',
          eventData: {
            status,
          },
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    phoneFormat(phoneNum) {
      if (Number(phoneNum) && String(phoneNum).length === 11) {
        const mb = String(phoneNum);
        const reg = /^(\d{3})\d{4}(\d{4})$/;
        return mb.replace(reg, '$1****$2');
      }
      return phoneNum;
    },
    bindPhoneClick() {
      this.isShowBindPhone = true;
    },
    handleBindPhoneClose() {
      this.isShowBindPhone = false;
      // this.move();
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    handleClose() {},
    blueChange() {
      window.scroll(0, this.scrollTop);
    },
    upglideLooeMoreClick(e) {
      this.showLookMoreButton = true;
    },
    /**
     * 点击查看更多
     */
    copyText() {
      tool.copyText('心悦俱乐部');
      Vue.prototype.$toast('复制公众号名称成功');
      if (this.$ast.isAPP()) {
        // 当期页面切换成微信
        window.Tgclub && window.Tgclub.openApp('com.tencent.mm');
      }
    },
    reportBindPhoneFunc(status) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_phone',
          eventData: {
            status,
          },
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    closeBindOrderPhone(status) {
      if (!this.isShowBindPhone) {
        this.visible();
        this.$emit('closeBindOrderPhone', status);
        this.showLookMoreButton = false;
      }
    },
    async reportSilentDownload() {
      // 获取游戏包名称
      const actId = Vue.prototype?.$actInfo?.activity_id;
      console.log('reportSilentDownload check actId = ', actId);
      if (actId !== 10524) {
        this.handleClose();
        console.log(' stop reportSilentDownload check actId = ', actId);
        return false;
      }
      console.log(' access reportSilentDownload check actId = ', actId);

      if (!this.packageName) {
        const androidPkgName = await TgclubApi.queryGamePackageName(this.subscriptionData.gid);
        if (!androidPkgName) {
          this.$alert({ msg: '获取安卓游戏包名失败' });
          return false;
        }
        this.packageName = androidPkgName;
      }
      const reportData = {
        gid: this.subscriptionData.gid,
        packageName: this.packageName,
        operType: this.wifiAutoDownloadDisabled ? 0 : 1,
      };
      const response = await TgclubApi.reportSilentDownload(reportData);
      console.log('reportSilentDownload response  =', response);
      const { ret, msg } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '操作失败' });
      }
      this.handleClose();
    },
    // sx 跳转
    async jumpAward(link) {
      this.$ast.openView({ url: link });
    },
    // phoneFormatIsOk(phone) {
    //   return /^1[3456789]\d{9}$/.test(phone);
    // },
    // async save() {
    //   console.log(' this.wifiAutoDownloadDisabled ', this.wifiAutoDownloadDisabled);
    //   if (this.openNoticeMsg === true) {
    //     if (!this.phone) {
    //       return this.$toast('请输入11位手机号');
    //     }
    //     // 设置短信通知
    //     if (!this.phoneFormatIsOk(this.phone)) {
    //       return this.$toast('请输入正确格式手机号');
    //     }
    //   }

    //   const reportData = {
    //     gid: this.subscriptionData.gid,
    //     mobile: this.phone && this.phoneFormatIsOk(this.phone) ? this.phone : '',
    //     countrycode: '86',
    //     switch_status: this.openNoticeMsg ? 0 : 1,
    //   };
    //   const response = await TgclubApi.saveMobSubscription(reportData);
    //   console.log('saveMobSubscription response  =', response);
    //   const { ret, msg } = response || {};
    //   if (ret !== 0) {
    //     this.$alert({ msg: msg || '操作失败' });
    //     this.reportBindPhoneFunc('0');
    //   }
    //   this.reportBindPhoneFunc('1');

    //   if (!this.isIOS) {
    //     this.reportSilentDownload();
    //     return false;
    //   }
    //   this.handleClose(true);
    // },
  },
};
</script>
<style lang='scss'>
@import './styles.scss';
</style>
